import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { supabase } from "@/integrations/supabase/client";
import { Loader2, Mail } from "lucide-react";

export function BookingAccessRecovery({ bookingId }: { bookingId?: string }) {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const requestLink = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!bookingId || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return;
    setSubmitting(true);
    await supabase.functions.invoke("manage-booking", {
      body: {
        action: "request_access",
        booking_id: bookingId,
        customer_email: email.trim(),
      },
    });
    setSubmitting(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md rounded-xl border bg-card p-6 shadow-sm">
        <div className="mb-5 flex items-center gap-3">
          <div className="rounded-full bg-primary/10 p-2">
            <Mail className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h1 className="text-xl font-semibold">
              Secure booking link required
            </h1>
            <p className="text-sm text-muted-foreground">
              This link is missing, invalid, or expired.
            </p>
          </div>
        </div>
        {sent
          ? (
            <p className="text-sm text-muted-foreground">
              If that email matches this booking, a fresh secure link will
              arrive shortly.
            </p>
          )
          : (
            <form className="space-y-4" onSubmit={requestLink}>
              <div className="space-y-2">
                <Label htmlFor="booking-recovery-email">Booking email</Label>
                <Input
                  id="booking-recovery-email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  required
                />
              </div>
              <Button className="w-full" disabled={submitting || !bookingId}>
                {submitting &&
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                Email me a secure link
              </Button>
            </form>
          )}
      </div>
    </div>
  );
}
